export default {
  progress: '{0} von {1}',
};
